export const ESPACAMENTO = 16;
export const ARREDONDAMENTO = 16;
export const LARGURA_PRODUTO = 118;
export const ASPECTO_DESTAQUE = 398 / 193;
export const ASPECTO_QUADRADO = 1;
// Cinza claro do app (lightBackground).
export const COR_DE_FUNDO_PADRAO = '#F4F4F4';
